import { NextPage } from 'next';
import Link from 'next/link';

import { PublicPageLayout } from '../components/PublicPageLayout';

const ThankYouNextPage: NextPage = () => {
  return (
    <PublicPageLayout title="Your email is on its way!">
      <p className="text-center">
        The tribe will receive your email shortly, while you wait for a reply jump back to the{' '}
        <Link href="/">
          <span className="text-underline">home page</span>
        </Link>{' '}
        or have a read of our blog{' '}
        <Link href="/blog">
          <span className="text-underline">here</span>
        </Link>
        .
      </p>
    </PublicPageLayout>
  );
};

// eslint-disable-next-line import/no-default-export
export default ThankYouNextPage;
